module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', [_c('div', {
    staticClass: "item"
  }, [_vm._v("订单编号：" + _vm._s(_vm.order.id))]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("设备编号：" + _vm._s(_vm.order.deviceId))]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("套餐名称：" + _vm._s(_vm.order.orderPackage.packageName))]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("订单金额：" + _vm._s(_vm.order.orderPackage.packagePrice * _vm.order.quantity))]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("订单状态：" + _vm._s(_vm.orderStatus[_vm.order.status]))]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("\n        选择支付方式：\n        "), _c('el-radio', {
    staticClass: "item-radio",
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.payMethod),
      callback: function($$v) {
        _vm.payMethod = $$v
      },
      expression: "payMethod"
    }
  }, [_vm._v("支付宝")])], 1), _vm._v(" "), _c('div', {
    staticClass: "item center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.start
    }
  }, [_vm._v("立刻支付")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-696f2c61","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/client/order.vue
// module id = 1163
// module chunks = 2